import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from 'services/api';
import { useClock, useConnectionStatus, SOC_SCREENS } from './useCommandData';
import useSocket from 'hooks/useSocket';
import './commandement.css';

export default function CommandementAgents() {
  const navigate = useNavigate();
  const { timeStr, dateStr } = useClock();
  const [sites, setSites] = useState([]);
  const [data, setData] = useState(null);

  const fetchData = useCallback(async () => {
    const [s, d] = await Promise.all([
      api.get('/sites/map-data').then(r => r.data).catch(() => []),
      api.get('/dashboard').then(r => r.data).catch(() => null),
    ]);
    setSites(s);
    setData(d);
  }, []);

  const { connected, reconnected, lastTimeStr } = useConnectionStatus(fetchData, 60000);

  useSocket({
    'agent:statut': () => fetchData(),
    'ronde:update': () => fetchData(),
  });

  const agentsActifs = data?.agents?.actifs || 0;
  const agentsTotal = data?.agents?.total || 0;

  const getBadge = (site) => {
    if (!site.actif) return { cls: 'cmd-badge-empty', label: 'INACTIF' };
    if (site.incidents_actifs > 0) return { cls: 'cmd-badge-incident', label: 'INCIDENT ACTIF' };
    if (site.agents_presents === 0) return { cls: 'cmd-badge-empty', label: 'AUCUN AGENT' };
    return { cls: 'cmd-badge-op', label: 'OPERATIONNEL' };
  };

  const now = new Date();
  const mois = ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aout', 'Sep', 'Oct', 'Nov', 'Dec'];

  return (
    <div className="cmd-root">
      {!connected && <div className="cmd-banner cmd-banner-error">⚠️ CONNEXION PERDUE — Derniere mise a jour : {lastTimeStr} — Reconnexion en cours...</div>}
      {reconnected && <div className="cmd-banner cmd-banner-ok">✅ CONNEXION RETABLIE</div>}

      <header className="cmd-header">
        <div className="cmd-header-left">
          <div className="cmd-logo">G</div>
          <span className="cmd-header-title">AGENTS & RONDES — {mois[now.getMonth()].toUpperCase()} {now.getFullYear()}</span>
        </div>
        <div className="cmd-header-right">
          <span style={{ fontSize: 12, color: '#aaa' }}>{agentsActifs}/{agentsTotal} en service</span>
          <span className="cmd-date">{dateStr}</span>
          <span className="cmd-clock">{timeStr}</span>
          <button className="cmd-back-btn" onClick={() => navigate('/commandement')}>RETOUR</button>
        </div>
      </header>

      <div className="cmd-agents-body">
        <div className="cmd-agents-grid">
          {sites.length === 0 && (
            <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: 60, color: '#555' }}>Chargement des sites...</div>
          )}
          {sites.map(site => {
            const badge = getBadge(site);
            return (
              <div key={site.id} className="cmd-site-card">
                <div className="cmd-site-code">{site.code_militaire || site.nom}</div>
                <div className="cmd-site-client">{site.client_nom || '—'}</div>
                <div className="cmd-site-stats">
                  <div>Agents : <strong style={{ color: '#fff' }}>{site.agents_presents}</strong></div>
                  <div>
                    <span className={`cmd-site-badge ${badge.cls}`}>{badge.label}</span>
                  </div>
                  {site.incidents_actifs > 0 && (
                    <div style={{ color: '#FF1744', fontSize: 11 }}>{site.incidents_actifs} incident(s) actif(s)</div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="cmd-rondes-bar">
        <span style={{ fontFamily: 'Orbitron, sans-serif', fontSize: 10, letterSpacing: 2, color: '#888', flexShrink: 0 }}>RONDES EN COURS :</span>
        <span style={{ color: '#555' }}>Aucune ronde active — données temps reel a venir</span>
      </div>

      <div className="cmd-status-bar">
        {SOC_SCREENS.map(s => (
          <div key={s.label} className="cmd-status-item">
            <span className="cmd-status-led" />
            <span className="cmd-status-label">{s.label} {s.status}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
